import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import config from '../../../config';
import {Note} from "../../../classes/note";
import {kanLoadingService} from "./loading";

@Injectable()
export class kanNotesService {
    constructor(private http: HttpClient,
                private loadingService: kanLoadingService) {
    }

    public getNotes(filter: object = {}): Promise<Note[]> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/notes`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let notes = response.map((note) => {
                        note.start = note.start ? new Date(note.start) : null;
                        note.end = note.end ? new Date(note.end) : null;
                        return note;
                    });
                    resolve(notes as Note[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public countNotes(filter: any = {}): Promise<number> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('where', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/notes/count`, {params: params})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone.count as number);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getUserNotes(userId): Promise<Note[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    userId: userId
                },
                order: 'start DESC',
                include: ['dog']
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/notes`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let notes = response.map((note) => {
                        note.start = note.start ? new Date(note.start) : null;
                        note.end = note.end ? new Date(note.end) : null;
                        return note;
                    });
                    resolve(notes as Note[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getDogNotes(dogId): Promise<Note[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    dogId: dogId
                },
                order: 'start DESC'
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/notes`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let notes = response.map((note) => {
                        note.start = note.start ? new Date(note.start) : null;
                        note.end = note.end ? new Date(note.end) : null;
                        return note;
                    });
                    resolve(notes as Note[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addNote(note: Note): Promise<Note> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/notes`, note)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Note);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateNote(note: Note): Promise<Note> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/notes/${note.id}`, note)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve(response as Note);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public removeNote(note: Note): Promise<any> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.delete(`${config.apiRootUrl}/api/notes/${note.id}`)
                .toPromise()
                .then((response: any) => {
                    this.loadingService.hide();
                    resolve();
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/notes.ts